import { create } from 'zustand';
import { authApi } from '../api/client';

const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  login: async (email, password) => {
    const { data } = await authApi.login(email, password);
    localStorage.setItem('access_token', data.access);
    localStorage.setItem('refresh_token', data.refresh);
    // Vollständiges Profil laden — bei Fehler trotzdem einloggen
    // (Dashboard erkennt fehlendes customer-Objekt und lädt nach)
    try {
      const { data: me } = await authApi.me();
      set({ user: me, isAuthenticated: true, isLoading: false });
    } catch {
      set({ user: data, isAuthenticated: true, isLoading: false });
    }
    return data;
  },

  logout: async () => {
    const refresh = localStorage.getItem('refresh_token');
    try { await authApi.logout(refresh); } catch {}
    // Nur Auth-Tokens entfernen, Benutzereinstellungen (z.B. Panel-Breite) bleiben erhalten
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    set({ user: null, isAuthenticated: false });
  },

  loadUser: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) { set({ isLoading: false }); return; }
    try {
      const { data } = await authApi.me();
      set({ user: data, isAuthenticated: true, isLoading: false });
    } catch {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      set({ isLoading: false });
    }
  },
}));

export default useAuthStore;
